import { render, staticRenderFns } from "./PercorsoFormativoAlternanzaSign.vue?vue&type=template&id=79f51b7c&scoped=true&"
import script from "./PercorsoFormativoAlternanzaSign.vue?vue&type=script&lang=ts&"
export * from "./PercorsoFormativoAlternanzaSign.vue?vue&type=script&lang=ts&"
import style0 from "./PercorsoFormativoAlternanzaSign.vue?vue&type=style&index=0&id=79f51b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f51b7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VIcon,VRow})
